// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__15o0p","content":"LoadingAlert_content__2BiG_"};